module.exports = __webpack_public_path__ + "img/violet_129.528cffea.png";